/**
 * Centralized GSAP imports for tree-shaking optimization
 * Only import the GSAP modules that are actually used in the application
 */

// Core GSAP (required)
export { gsap } from 'gsap';

// Only import the easing functions we actually use
export { Expo, Bounce, Elastic, Power4, Power2, Power1, Linear } from 'gsap';

// Import only needed plugins
export { ScrollTrigger } from 'gsap/ScrollTrigger';

// Types we need
export type {
  Tween,
  Timeline,
  TweenVars,
  StaggerVars,
  GSAPTimeline,
  GSAPTween,
  CallbackType,
  TickerCallback,
  EaseFunction,
} from 'gsap';

// ScrollTrigger types
export type {
  ScrollTriggerInstance,
  ScrollTriggerVars,
  ScrollTriggerRefreshVars,
  ScrollTriggerCallback,
} from 'gsap/ScrollTrigger';

// Register plugins (do this once at app initialization)
import { gsap as gsapCore } from 'gsap';
import { ScrollTrigger as ScrollTriggerPlugin } from 'gsap/ScrollTrigger';

// Only register plugins we actually use
gsapCore.registerPlugin(ScrollTriggerPlugin);

// Enable automatic GPU-accelerated 3D transforms during animations.
// "auto" promotes elements to their own compositing layer while GSAP is
// actively animating transforms, then drops back to 2D when done —
// no permanent GPU memory cost.
gsapCore.config({ force3D: 'auto' });

// Note: TimelineLite and TweenLite are deprecated in GSAP 3
// They are now just aliases to Timeline and Tween
// We should update the code to use the modern API

// Export a function to check if GSAP is properly loaded
export const isGSAPReady = (): boolean => {
  return (
    typeof gsapCore !== 'undefined' &&
    typeof ScrollTriggerPlugin !== 'undefined'
  );
};

// Export the core gsap object for direct access if needed
export const gsapInstance = gsapCore;
